(function () {
  function setOpen(step, open) {
    var trigger = step.querySelector(".real-issue__trigger");

    step.classList.toggle("is-open", open);

    if (trigger) {
      trigger.setAttribute("aria-expanded", open ? "true" : "false");
    }
  }

  function initList(list) {
    if (!list || list.dataset.realIssueInit === "true") {
      return;
    }

    list.dataset.realIssueInit = "true";

    list.addEventListener("click", function (event) {
      var trigger = event.target.closest(".real-issue__trigger");

      if (!trigger || !list.contains(trigger)) {
        return;
      }

      var step = trigger.closest(".real-issue__step");
      var isOpen = step.classList.contains("is-open");

      list.querySelectorAll(".real-issue__step.is-open").forEach(function (openStep) {
        if (openStep !== step) {
          setOpen(openStep, false);
        }
      });

      setOpen(step, !isOpen);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll(".real-issue__list").forEach(initList);
  }

  initAll();

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
